import React from 'react';

import { SVGComponentProps } from './svg.types';

const CommentSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width="12"
        height="13"
        viewBox="0 0 12 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.57094 9.17857H7.82094V9.92857V11L5.59237 9.32857L5.39237 9.17857H5.14237H2.99951C1.75687 9.17857 0.749512 8.17121 0.749512 6.92857V3.5C0.749512 2.25736 1.75687 1.25 2.99951 1.25H8.99951C10.2422 1.25 11.2495 2.25736 11.2495 3.5V6.92857C11.2495 8.17121 10.2422 9.17857 8.99951 9.17857H8.57094Z"
          stroke="#878A92"
          strokeWidth="1.5"
        />
      </svg>
    </span>
  );
};

export default CommentSVG;
